<template>
  <div>
    <AppChart
      :chart="chart"
      v-for="(chart, index) in charts"
      :key="index"
      class="column"
      :class="charts.length === 1 ? 'is-full' : fullSize === true ? 'is-half' : 'is-one-third'"
    ></AppChart>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {
    AppChart: () => import(/* webpackChunkName: "AppChart" */ '@/components/shared/AppChart')
  },
  props: {
    charts: {
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('dashboard', {
      fullSize: 'fullSize'
    })
  }
};
</script>

<style lang="scss" scoped></style>
